<template>
  <div>
    <div v-if="isUpdateModeEnabled">
      <new-message-form
        @EventNewMessageData="getNewMessageData"
      ></new-message-form>
    </div>
    <div
      v-for="message_json in messages"
      :key="message_json.docId"
      class="col-md-11"
    >
      <div class="panel-collapse">
        <ul class="chat">
          <li class="left clearfix">
            <div class="chat-body clearfix">
              <div class="header">
                <strong v-if="message_json.subject" class="primary-font">{{
                  message_json.subject
                }}</strong>
                <small class="float-right text-muted">
                  <span class="glyphicon glyphicon-time"></span>
                  {{ message_json.relativeTimeString }}</small>
              </div>
              <p v-linkified>
                {{ message_json.message }}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
//import linkify from 'vue-linkify';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import NewMessageForm from './NewMessageForm.vue';

var config = {
  apiKey: 'AIzaSyCzXcjQOoHitr4JTB-lDk6fGc_u7Kb6hEY',
  authDomain: 'etell-me.firebaseapp.com',
  databaseURL: 'https://etell-me.firebaseio.com',
  projectId: 'etell-me',
  storageBucket: 'etell-me.appspot.com',
  messagingSenderId: '586485351569',
  appId: '1:586485351569:web:29b6d0fbbcde1894412b30',
  measurementId: 'G-73DV8BBJ4D',
};

firebase.initializeApp(config);

let db = firebase.firestore();
let collectionPrefix = 'tag_';

export default {
  name: 'MessagePage',
  props: ['tag'],
  components: { NewMessageForm },
  data: () => {
    return {
      pageName: 'MessagePage',
      messages: [],
      isUpdateModeEnabled: true,
    };
  },

  mounted() {
    this.updateMode = this.$store.state.updateMode;
  },

  beforeRouteUpdate(to, from, next) {
    next();
  },

  created: function() {
    this.$emit('PageNameChanged', this.pageName);
    console.log('PageNameChanged triggered from Message page.');
    //this.getMessages();
    this.syncMessages();
  },

  methods: {
    getMessages() {
      const docRef = db.collection(collectionPrefix + this.tag);
      const docs = docRef.orderBy('timestamp', 'desc').limit(3);
        docs.get()
        .then((querySnapshot) => {
          let messages = [];
          console.log(querySnapshot.length);
          querySnapshot.forEach((doc) => {
            messages.push(doc.data());
          });
          this.messages = messages;
        })
        .catch((err) => {
          console.log('Error getting document', err);
        });
    },

    getRelativeTime(theTimestamp) {
      try{
        return moment(theTimestamp.toDate()).fromNow();
      } catch {
        //
      }
    },

    getNewMessageData(formData) {
      console.log("getNewMessageData", formData.message, formData.subject);
      this.createNewMessage({
        timestamp:  firebase.firestore.FieldValue.serverTimestamp(),
        subject: formData.subject,
        message: formData.message,
      });
    },

    createNewMessage(message) {
      // message: {subject:'', message: '', timestamp: ''}
      console.log(`new message: ${message.message}`);
      db.collection(collectionPrefix + this.tag)
        .add(message)
        .then((documentReference) => {
          console.log(`Added document with name: ${documentReference.id}`);
        });
    },

    syncMessages() {
      let vm = this;
      db.collection(collectionPrefix + this.tag).orderBy('timestamp', 'desc').onSnapshot((snapshot) => {
        let messages = [];
        snapshot.docs.forEach(doc => {
          let message_json = doc.data();
          const docId = doc.id;
          if (message_json.timestamp) {
            message_json.relativeTimeString = vm.getRelativeTime(message_json.timestamp);
          } else {message_json.relativeTimeString = '';}
          message_json.docId = docId;
          messages.push(message_json);
        });
        vm.messages = messages;
      });
    },
  },

  computed: {
    updateMode: {
      get() {
        return this.$store.state.updateMode;
      },
      set(newStatus) {
        return newStatus;
      },
    },
  },

  watch: {
    updateMode(newStatus, oldStatus) {
      this.isUpdateModeEnabled = newStatus;
      console.log(`state changed from ${oldStatus} to ${newStatus}`);
    },
  },
};
</script>
